import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ContactLogo from '../components/shared/ContactLogo';

/* Catch-all for any URL that doesn't match a real route (typo, dead
   link, expired share). Previously there was no such route at all, so
   an unmatched URL rendered a blank white screen with no way forward. */
const NotFoundPage = () => {
  const navigate = useNavigate();

  // This app is served as a static SPA build, so an unmatched URL still
  // gets a 200 from the hosting layer (it can't know upfront whether a
  // path is a valid client route) — there's no way to set a real HTTP 404
  // from here. A JS-injected noindex is Google's own documented workaround
  // for exactly this case: Googlebot renders the page, reads this tag, and
  // drops the URL from the index on its next crawl even though the
  // response was a 200. Removed on unmount so it can never leak onto a
  // real page if the user navigates on within the same SPA session.
  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, nofollow';
    document.head.appendChild(meta);
    return () => { document.head.removeChild(meta); };
  }, []);

  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-4">
      <div className="max-w-md w-full text-center">
        <div className="mb-8 flex justify-center">
          <ContactLogo className="h-8 w-auto" clickable />
        </div>
        <div style={{ fontSize: 72, fontWeight: 700, color: '#0A0A0A', letterSpacing: '-0.03em', lineHeight: 1 }}>404</div>
        <h1 style={{ fontSize: 20, fontWeight: 600, color: '#1d1d1f', marginTop: 16, letterSpacing: '-0.01em' }}>
          Esta página no existe
        </h1>
        <p style={{ fontSize: 14.5, color: '#6e6e73', marginTop: 8, marginBottom: 32, lineHeight: 1.5 }}>
          Puede que el enlace esté mal escrito o ya no esté disponible.
        </p>
        <button
          onClick={() => navigate('/')}
          style={{
            background: '#000',
            color: '#fff',
            padding: '14px 32px',
            borderRadius: 100,
            fontSize: 15,
            fontWeight: 600,
            border: 'none',
            cursor: 'pointer',
          }}
        >
          Volver al inicio
        </button>
      </div>
    </div>
  );
};

export default NotFoundPage;
